export default __webpack_public_path__ + "static/media/no_entry.41c58d98.svg";